@if (_notice(); as notice) {
  <div
    class="degraded-notice m-flex m-gap:2 m-flex-items:start m-padding:2 m-border-radius:lg m-bg-color:warning-pale m-text-color:warning-dark m-text-body:small"
    role="status"
  >
    <i class="myre-icon-warning"></i>
    <span>{{ notice.message }}</span>
  </div>
}
